import 'core-js/stable';
import 'regenerator-runtime/runtime';
import { StrictMode, useEffect } from 'react';
import * as ReactDOM from 'react-dom/client';
import { Theme } from '@versita/frontend/campus-ui-web';
import { Provider } from 'react-redux';
import { store } from './state';
import App from './App';
import { WithAuth } from '@versita/frontend/auth-web';
import { NotifyErrors } from './NotifyErrors';
import { httpClientIntegration } from '@sentry/integrations';
import * as Sentry from '@sentry/react';
import environment from './environments/environment';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';

Sentry.init({
  dsn: 'https://b69065937fa8495d9c22c109dac63302@o494986.ingest.sentry.io/5566975',
  environment: environment.name,
  integrations: [
    new Sentry.BrowserProfilingIntegration(),
    new Sentry.BrowserTracing({
      routingInstrumentation: Sentry.reactRouterV6Instrumentation(
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      ),
      tracePropagationTargets: [environment.apis.studentPortalApi.endpoint],
    }),
    new Sentry.Replay(),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    httpClientIntegration() as any,
  ],
  tracesSampleRate: 0.001,
  enabled: environment.production,
  replaysSessionSampleRate: 0.001,
  replaysOnErrorSampleRate: 0.001,
  _experiments: {
    profilesSampleRate: 0.001,
  },
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

const Main = () => (
  <StrictMode>
    <Provider store={store}>
      <WithAuth>
        <Theme>
          <NotifyErrors />
          <Sentry.ErrorBoundary
            showDialog
            fallback={<p>Something went wrong. Please try again later.</p>}
          >
            <App />
          </Sentry.ErrorBoundary>
        </Theme>
      </WithAuth>
    </Provider>
  </StrictMode>
);

root.render(<Main />);
